import React from 'react';
import cn from 'classnames';
import { Icon } from 'legacy-packages/ft-cb';
import PopOver from 'chameleon/ui-stack/ui/base/popover';

import './DetailsPopover.scss';

const EXAM_ALIGNMENT_ACCESSIBILITY_TEXT = `""Perfect:""Perfect alignment to articulated course and exam.""
Strong:""Represents skill or content that is in the course, though not asked in the format of the articulated exam.""
Moderate:""Represents skill or content that is in the course, but mismatched or at a level lower than the course suggests.""
Minimal:""Prerequisite knowledge for course content, but not (directly) assessed on the exam.""
`;

const NEW_EXAM_ALIGNMENT_ACCESSIBILITY_TEXT = `
""High:""These questions have high alignment to the current course and exam.
They assess skills or content in the course and on the exam. However, the
question format may not perfectly match the exam.""
Partial:""These questions have partial alignment to the current course and exam.
They assess skills or content relevant to the course; however, questions
may assess prerequisite content knowledge, content at a lower level than
the exam, or content slightly outside the scope of the course. They may
not fully or precisely assess current course skills. These questions are
provided for teachers who may wish to use them as students develop their
knowledge and skills.""
`;

const EXAM_ALIGNMENT_DETAILS_TEXT = (
  <div
    aria-live="assertive"
    id="filter-details-tooltip"
    className="filter-details-container"
    aria-label={EXAM_ALIGNMENT_ACCESSIBILITY_TEXT}
  >
    <div className="filter-details-value-container">
      <span className="filter-details-value">Perfect:</span>
      <span className="filter-details-value-description">
        Perfect alignment to articulated course and exam.
      </span>
    </div>
    <div className="filter-details-value-container">
      <span className="filter-details-value">Strong:</span>
      <span className="filter-details-value-description">
        Represents skill or content that is in the course, though not asked in
        the format of the articulated exam.
      </span>
    </div>
    <div className="filter-details-value-container">
      <span className="filter-details-value">Moderate:</span>
      <span className="filter-details-value-description">
        Represents skill or content that is in the course, but mismatched or at
        a level lower than the course suggests.
      </span>
    </div>
    <div className="filter-details-value-container">
      <span className="filter-details-value">Minimal:</span>
      <span className="filter-details-value-description">
        Prerequisite knowledge for course content, but not (directly) assessed
        on the exam.
      </span>
    </div>
  </div>
);

const NEW_EXAM_ALIGNMENT_DETAILS_TEXT = (
  <div
    aria-live="assertive"
    id="filter-details-tooltip"
    className="filter-details-container"
    aria-label={NEW_EXAM_ALIGNMENT_ACCESSIBILITY_TEXT}
  >
    <div className="filter-details-value-container">
      <span className="filter-details-value">High:</span>
      <span className="filter-details-value-description">
        These questions have high alignment to the current course and
        exam.&nbsp; They assess skills or content in the course and on the exam.
        However, the&nbsp; question format may not perfectly match the exam.
      </span>
    </div>
    <br />
    <div className="filter-details-value-container">
      <span className="filter-details-value">Partial:</span>
      <span className="filter-details-value-description">
        These questions have partial alignment to the current course and exam.
        They assess skills or content relevant to the course; however, questions
        may assess prerequisite content knowledge, content at a lower level than
        the exam, or content slightly outside the scope of the course. They may
        not fully or precisely assess current course skills. These questions are
        provided for teachers who may wish to use them as students develop their
        knowledge and skills.
      </span>
    </div>
  </div>
);

export const FILTER_DETAILS = [
  {
    name: 'Exam Alignment',
    details: (showNewExamAlignmentText) =>
      showNewExamAlignmentText
        ? NEW_EXAM_ALIGNMENT_DETAILS_TEXT
        : EXAM_ALIGNMENT_DETAILS_TEXT,
  },
];

const DetailsPopover = ({
  className,
  popOverClassName,
  tagCategoryDescription,
  details,
  onOpen = () => {},
  ...otherProps
}) => {
  const iconClassName = cn('details-popover', popOverClassName, {
    [`${className}-details`]: className,
  });
  const ariaLabel = `${tagCategoryDescription} clickable tooltip`;
  const detailsLabel = (
    <div className="details-label-icon">
      <Icon
        name="circle_info"
        size="1.2em"
        className="fill-current text-gray-600"
      />
    </div>
  );

  return (
    <PopOver
      {...otherProps}
      size="wide"
      className={iconClassName}
      buttonClassName="details-popover-btn"
      contentClassName="leading-normal"
      onOpen={onOpen}
      accessibility={{
        'aria-label': ariaLabel,
        'aria-describedby': 'filter-details-tooltip',
      }}
      trigger={detailsLabel}
    >
      {details}
    </PopOver>
  );
};

export default DetailsPopover;
